export default {"src":"/_next/static/media/icon-edit.4d1ecaf4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};